import DataModel from "./DataModel";

class RuleConditionType extends DataModel {
	constructor() {
		super('rules/conditions/types')
	}
}

export default RuleConditionType;
